var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentUpload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1146 1.94528C10.0395 1.87027 9.9378 1.82812 9.83171 1.82812H3.9974C3.64377 1.82813 3.30464 1.9686 3.05459 2.21865C2.80454 2.4687 2.66406 2.80784 2.66406 3.16146V13.8281C2.66406 14.1817 2.80454 14.5209 3.05459 14.7709C3.30464 15.021 3.64377 15.1615 3.9974 15.1615H11.9974C12.351 15.1615 12.6902 15.021 12.9402 14.7709C13.1903 14.5209 13.3307 14.1817 13.3307 13.8281V5.32714C13.3307 5.22106 13.2886 5.11932 13.2136 5.0443L10.1146 1.94528Z",
    stroke: "#67768E",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13281 12H9.8957",
    stroke: "#67768E",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01562 10.3566V7.26562",
    stroke: "#67768E",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29688 8.16667L7.93538 6.56813C7.97422 6.53023 8.0362 6.53023 8.07504 6.56813L9.71354 8.16667",
    stroke: "#67768E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/documentUpload.1d757d7ea4e8c5dfd3cd1055befe253b.svg";
export { ForwardRef as ReactComponent };